import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
import idID from "antd/locale/id_ID";
import { ConfigProvider } from "antd";
import pallete from "./utils/pallete.js";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ConfigProvider
      locale={idID}
      theme={{
        token: {
          colorPrimary: pallete.primary[400],
          fontFamily: "Plus Jakarta Sans",
        },
        components: {
          Menu: {
            itemColor: pallete.grey[500],
            itemHoverColor: pallete.primary[400],
            collapsedIconSize: 15,
          },
          Table: {
            headerSplitColor: "",
            headerBorderRadius: 0,
          },
          Form: {
            itemMarginBottom: 16,
            verticalLabelMargin: "0 0 -3px 0",
            labelFontSize: 13,
            labelColor: pallete.grey[800],
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  </StrictMode>
);
